const TeamCenter = {
  state: () => ({
    bind_room_id: '', // 绑定房间id
    bind_channel_id: '', // 绑定频道id
    room_public_id: '', // 房间公共id
    sync_to_room: false, // 是否同步到房间
    firepower_switch: true, // 是否显示命运2火力人数开关
    bungie_api_key: '', // 命运2火力人数key
    select_appid: '', // 当前选择的appid
    wait_time_filter: {},
    game_list: [],
    force_focus: false,
    req_params: {},
    new_link_count: 0,
    last_update_time: 0,
    is_matching: false,
    match_params: {},
    match_room_channel: {},
    match_time: 0,
    match_interval: null,
  }),
  getters: {
    bind_room_id: (state) => state.bind_room_id,
    bind_channel_id: (state) => state.bind_channel_id,
    room_public_id: (state) => state.room_public_id,
    sync_to_room: (state) => state.sync_to_room,
    firepower_switch: (state) => state.firepower_switch,
    bungie_api_key: (state) => state.bungie_api_key,
    select_appid: (state) => state.select_appid,
    wait_time_filter: (state) => state.wait_time_filter,
    game_list: (state) => state.game_list,
    force_focus: (state) => state.force_focus,
    req_params: (state) => state.req_params,
    new_link_count: (state) => state.new_link_count,
    last_update_time: (state) => state.last_update_time,
    is_matching: (state) => state.is_matching,
    match_params: (state) => state.match_params,
    match_room_channel: (state) => state.match_room_channel,
    match_time: (state) => state.match_time,
    match_interval: (state) => state.match_interval,
  },
  mutations: {
    SET_BIND_ROOM_ID: (state, payload) => {
      state.bind_room_id = payload
    },
    SET_BIND_CHANNEL_ID: (state, payload) => {
      state.bind_channel_id = payload
    },
    SET_ROOM_PUBLIC_ID: (state, payload) => {
      state.room_public_id = payload
    },
    SET_SYNC_TO_ROOM: (state, payload) => {
      state.sync_to_room = payload
    },
    SET_FIREPOWER_SWITCH: (state, payload) => {
      state.firepower_switch = payload
    },
    SET_BUNGIE_API_KEY: (state, payload) => {
      state.bungie_api_key = payload
    },
    SET_SELECT_APPID: (state, payload) => {
      state.select_appid = payload
    },
    SET_WAIT_TIME_FILTER: (state, payload) => {
      state.wait_time_filter = payload
    },
    SET_GAME_LIST: (state, payload) => {
      state.game_list = payload
    },
    SET_FORCE_FOCUS: (state, payload) => {
      state.force_focus = payload
    },
    SET_REQ_PARAMS: (state, payload) => {
      state.req_params = payload
    },
    SET_NEW_LINK_COUNT: (state, payload) => {
      state.new_link_count = payload
    },
    SET_LAST_UPDATE_TIME: (state, payload) => {
      state.last_update_time = payload
    },
    SET_IS_MATCHING: (state, payload) => {
      state.is_matching = payload
    },
    SET_MATCH_PRAMAMS: (state, payload) => {
      state.match_params = payload
    },
    SET_MATCH_ROOM_CHANNEL: (state, payload) => { 
      state.match_room_channel = payload
    },
    SET_MATCH_TIME: (state, payload) => {
      state.match_time = payload
    },
    CLEAR_MATCH_INTERVAL: (state) => {
      if(state.match_interval) {
        clearInterval(state.match_interval)
        state.match_interval = null
      }
    },
    START_MATCH_INTERVAL: (state, cb) => {
      state.match_interval = setInterval(() => {
        state.match_time++
        if(state.match_time >= 60 * 60 * 2) {
          cb && cb()
        }
      }, 1000)
    },
  },
  actions: {

  }
}
export default TeamCenter